
<template>
	<div>
		<div class="row">
			<div class="col-md-12">
				<div class="alert alert-info" role="alert">
					<h4 class="alert-heading">Внимание!</h4>
					<p>Этот раздел для сотрудников со специальными правами. Что бы узнать кто может им управлять, обратитесь в раздел разработки.</p>
				</div>
				<div class="card">
					<div class="card-header">Редактирование сотрудника</div>
					<div class="card-body">
						<b-alert :show="showAlertError" variant="danger">
							<ul>
								<li v-for="(error, key) in errors" :key="key">{{ error[key] }}</li>
							</ul>
						</b-alert>

						<b-alert variant="success"
							dismissible
							:show="showAlertSucces"
							@dismissed="showAlertSucces=false">
							Данные успешно обновлены!
						</b-alert>

						<div class="row">
							<div class="col-md-6">
								<b-form @submit="submitFormHandler">
									{{ errors.first_name }}
									<b-form-group label="Имя" :class="{ 'has-error': typeof this.errors['first_name'] !== 'undefined' }">
										<b-form-input
											v-model="form.firstName"
											required>
										</b-form-input>
										<div class="invalid-feedback">{{ getError('first_name') }}</div>
									</b-form-group>
									<b-form-group label="Фамилия" :class="{ 'has-error': typeof this.errors['last_name'] !== 'undefined' }">
										<b-form-input
											v-model="form.lastName"
											required>
										</b-form-input>
										<div class="invalid-feedback">{{ getError('last_name') }}</div>
									</b-form-group>
									<!-- email -->
									<b-form-group label="Адрес электроной почты" :class="{ 'has-error': typeof this.errors['email'] !== 'undefined' }">
										<b-form-input
											v-model="form.email"
											autocomplete="off"
											required>
										</b-form-input>
										<div class="invalid-feedback">{{ getError('email') }}</div>
									</b-form-group>
									<!-- password -->
									<fieldset class="b-form-group form-group horizontal">
										<vue-password-strength
											value="form.password"
											labelText="Нвый пароль"
											placeholder="Введите новый пароль"
											inputGroupClass=""
											labelClass="col-form-label"
											inputClass="form-control"
											@inputChange="passwordChangeHandler"
										/>
									</fieldset>
									<b-form-group label="" :class="{ 'has-error': typeof this.errors['password'] !== 'undefined' }">
										<b-form-input
											type="password"
											v-model="form.cPassword"
											placeholder="Введите новый пароль ещё раз">
										</b-form-input>
										<div class="invalid-feedback">{{ getError('password') }}</div>
									</b-form-group>
									<b-form-group id="role" label="Роль" label-for="role" class="is-required">
										<select class="form-control" v-model="form.role">
											<option v-for="(role, key) in roles" :key="key" :label="role.name" :value="role.system_name"></option>
										</select>
									</b-form-group>
									<!-- status -->
									<b-form-group id="status" label="Статус" label-for="status" class="is-required">
										<select class="form-control" v-model="form.status">
											<option v-for="(status, key) in statuses" :key="key" :label="status.value" :value="status.id"></option>
										</select>
									</b-form-group>
								</b-form>
							</div>
						</div>
					</div>
					<div class="card-footer">
						<b-button variant="primary" @click="submitFormHandler('form')">Сохранить изменения</b-button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import VuePasswordStrength from 'vue-password-strength'
import userAPI from '@/api/modules/user/user'
import ProductSelect from '@/components/product/ProductSelect'
import store from '@/store'
import Vue from 'vue'
export default {
	components: {
		VuePasswordStrength,
		'product-select': ProductSelect
	},
	data () {
		return {
			loaded: true,
			showAlertError: false,
			showAlertSucces: false,
			userId: '',
			type: null,
			status: '',
			role: '',
			form: {},
			roles: [],
			statuses: [
				{id: 1, value: 'Активен'},
				{id: 2, value: 'Заблокирован'}
			],
			errors: {}
		}
	},
	created () {
		this.userId = this.$route.params.id
		this.roleAll()
		this.getUser()
	},
	mounted () {
	},
	methods: {
		roleAll () {
			Vue.http.get(store.state.apiURL + '/v1/user/roles').then((response) => {
				this.roles = response.body
			})
		},
		getUser () {
			userAPI.findOne(this.userId).then((user) => {
				this.form = {
					firstName: user.first_name,
					lastName: user.last_name,
					email: user.email,
					status: user.status,
					role: user.role
				}
			})
		},
		getError (key) {
			if (typeof this.errors[key] !== 'undefined') {
				return this.errors[key][0]
			}
		},
		submitFormHandler (formName) {
			if (this.form.password !== this.form.cPassword) {
				alert('Пароли не совпадают.')
				return false
			}
			this.showAlertSucces = false
			let data = {
				first_name: this.form.firstName,
				last_name: this.form.lastName,
				email: this.form.email,
				password: this.form.password,
				status: this.form.status,
				role: this.form.role
			}

			userAPI.update(this.userId, data).then((result) => {
				this.clearErrors()
				this.showAlertSucces = true
				this.clearForm()
			}, (response) => {
				if (response.hasOwnProperty('errors')) {
					this.clearErrors()
					const errors = response.errors
					for (let key in errors) {
						this.errors[key] = errors[key]
					}
				}
				// this.showAlertError = true
			})
		},
		clearForm () {
			this.form.password = ''
			this.form.cPassword = ''
			// Object.keys(this.form).forEach((key, index) => {
			//	this.form[key] = ''
			// })
		},
		clearErrors () {
			this.errors = []
		},
		passwordChangeHandler (value) {
			this.form.password = value
		}
	}
}
</script>
<style>
	.el-alert {
		margin-bottom: 15px;
	}
</style>



// WEBPACK FOOTER //
// src/pages/user/update.vue